import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rate-card',
  templateUrl: './rate-card.component.html',
  styleUrls: ['./rate-card.component.scss']
})
export class RateCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
